import type { PropsWithChildren } from 'react';
import * as m from '@/paraglide/messages';
import { Button } from './Button';
import { FaqAccordion } from './subcomponents/FaqAccordion';

export function FAQ({
  title = m.faq_title(),
  description = m.faq_default_description(),
  faqs,
  showApplyButton = true,
  isScholarshipPage = false,
  children,
}: {
  title?: string;
  description?: string;
  faqs: Array<{
    question: string;
    answer: string;
  }>;
  showApplyButton?: boolean;
  isScholarshipPage?: boolean;
} & PropsWithChildren) {
  return (
    <section aria-labelledby='faq-title' className='py-16 lg:py-24'>
      <div className='mx-auto max-w-6xl px-4'>
        <h2
          className='mb-4 text-center text-3xl font-bold sm:text-4xl xl:text-6xl'
          id='faq-title'
        >
          {isScholarshipPage ? (
            <>
              {m.faq_scholarship_prefix()}{' '}
              <span className='text-azure-665'>Listening.com</span>{' '}
              {m.faq_scholarship_suffix()}
            </>
          ) : (
            title
          )}
        </h2>
        <p
          className='mx-auto mb-16 max-w-3xl text-center text-lg'
          id='faq-description'
        >
          {description}
        </p>

        <div aria-describedby='faq-description' className='mx-auto max-w-5xl'>
          <FaqAccordion aria-label='Frequently Asked Questions' faqs={faqs} />

          {showApplyButton && (
            <div className='mx-auto mt-12 flex max-w-3xl justify-center'>
              <Button
                ariaLabel='Apply for scholarship'
                className='w-full bg-white text-black hover:bg-white/90'
                href='https://le7wzm6nlsz.typeform.com/to/VYVdsZVn'
                targetBlank
              >
                {m.faq_apply_now()}
              </Button>
            </div>
          )}

          {children}
        </div>
      </div>
    </section>
  );
}
